import { render, staticRenderFns } from "./EocEmailSettings.vue?vue&type=template&id=10f701d0"
import script from "./EocEmailSettings.vue?vue&type=script&lang=ts"
export * from "./EocEmailSettings.vue?vue&type=script&lang=ts"
import style0 from "./EocEmailSettings.vue?vue&type=style&index=0&id=10f701d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports